import Validator from './validator.js';

export default class DateMinMaxValidator extends Validator {
    constructor(input) {
        super(input);
        this.field = this.input.parent;
    }

    valid() {
        const min = this.input.el.min;
        const max = this.input.el.max;
        const date = new Date(this.input.el.value);
        return (!min || (min && new Date(min) <= date)) && (!max || (max && new Date(max) >= date));
    }

    static applies(input) {
        return input.el.type === 'date';
    }
}
